import _toConsumableArray from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { extractTransformsFromEncoding } from './encoding';
import { SpecMapper } from './spec/map';

var TransformExtractMapper = /*#__PURE__*/function (_SpecMapper) {
  _inherits(TransformExtractMapper, _SpecMapper);

  var _super = _createSuper(TransformExtractMapper);

  function TransformExtractMapper() {
    _classCallCheck(this, TransformExtractMapper);

    return _super.apply(this, arguments);
  }

  _createClass(TransformExtractMapper, [{
    key: "mapUnit",
    value: function mapUnit(spec, _ref) {
      var config = _ref.config;

      if (spec.encoding) {
        var oldEncoding = spec.encoding,
            oldTransforms = spec.transform;

        var _extractTransformsFro = extractTransformsFromEncoding(oldEncoding, config),
            bins = _extractTransformsFro.bins,
            timeUnits = _extractTransformsFro.timeUnits,
            aggregate = _extractTransformsFro.aggregate,
            groupby = _extractTransformsFro.groupby,
            encoding = _extractTransformsFro.encoding;

        var transform = [].concat(_toConsumableArray(oldTransforms ? oldTransforms : []), _toConsumableArray(bins), _toConsumableArray(timeUnits), _toConsumableArray(!aggregate.length ? [] : [{
          aggregate: aggregate,
          groupby: groupby
        }]));
        return Object.assign({}, spec, transform.length > 0 ? {
          transform: transform
        } : {}, {
          encoding: encoding
        });
      } else {
        return spec;
      }
    }
  }]);

  return TransformExtractMapper;
}(SpecMapper);

var extractor = new TransformExtractMapper();
/**
 * Modifies spec extracting transformations from encoding and moving them to the transforms array
 */

export function extractTransforms(spec, config) {
  return extractor.map(spec, {
    config: config
  });
}